import { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import DetailPageLayout, { DetailSection } from '../utils/DetailPageLayout';
import CardContainer from '../utils/cardContainer';
import ThreeCard from '../utils/threeCard';
import FourCard from '../utils/fourCard';

function SingleTargetContent(props) {
  const { id } = useParams();
  const [data, setData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [hasError, setHasError] = useState(false);

  const url = `${process.env.REACT_APP_API_BASE_URL}/api/targets/${id}`;

  useEffect(() => {
    setIsLoading(true);
    fetch(url)
      .then((res) => res.json())
      .then((data) => setData(data))
      .catch((err) => setHasError(err))
      .finally(() => setIsLoading(false));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  if (isLoading) {
    return (
      <>
        <div className="detail-page">
          <p>Loading...</p>
        </div>
      </>
    );
  }

  if (hasError || !data) {
    return (
      <>
        <div className="detail-page">
          <p>Could not load this target.</p>
        </div>
      </>
    );
  }

  const meta = [];
  const typeLabel = [data.TargetType, data.SubType].filter(Boolean).join(' / ');
  if (typeLabel) meta.push({ label: 'Type', value: typeLabel });
  if (data.City || data.Country) {
    meta.push({ label: 'Location', value: `${data.City || 'Unknown'}, ${data.Country || ''}`.replace(/, $/, '') });
  }
  if (data.Lat && data.Lon) {
    meta.push({ label: 'Coordinates', value: `${data.Lat}, ${data.Lon}` });
  }

  const empty = (msg) => <p style={{ color: 'var(--color-ink-mute)', fontStyle: 'italic' }}>{msg}</p>;

  return (
    <>
      <DetailPageLayout eyebrow="Target" title={data.Name || 'Unnamed Target'} meta={meta}>
        {data.Description && (
          <DetailSection title="Description">
            <p>{data.Description}</p>
          </DetailSection>
        )}

        {data.Notes && (
          <DetailSection title="Notes">
            <p>{data.Notes}</p>
          </DetailSection>
        )}

        <DetailSection title="Missions">
          <CardContainer>
            {data.Missions && data.Missions.length > 0
              ? data.Missions.map(mission => (
                  <FourCard
                    key={mission.Id}
                    one={mission.Name}
                    two={mission.Date}
                    three={mission.Description}
                    link={`/missions/${mission.Id}`}
                  />
                ))
              : empty('No missions recorded for this target.')
            }
          </CardContainer>
        </DetailSection>

        <DetailSection title="Documents">
          <CardContainer>
            {data.Documents && data.Documents.length > 0
              ? data.Documents.map(doc => (
                  <ThreeCard
                    key={doc.Id}
                    one={doc.DocType}
                    two={doc.Description}
                    link={getDocUrl(doc.Id, doc.DocType)}
                  />
                ))
              : empty('No documents recorded for this target.')
            }
          </CardContainer>
        </DetailSection>
      </DetailPageLayout>
    </>
  );
}

const getDocUrl = (id, type) => {
  switch (type) {
    case 'map':
      return `/photos/${id}`;
    case 'photo':
      return `/photos/${id}`;
    case 'chart':
      return `/charts/${id}`;
    default:
      return '';
  }
};

export default SingleTargetContent;
